import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import { IconButton, Tooltip } from "@mui/material";

interface ToggleReadButtonProps {
  isRead: boolean;
  onClick: () => void;
}

const ToggleReadButton = ({ isRead, onClick }: ToggleReadButtonProps) => {
  return (
    <Tooltip title={isRead ? "Mark as unread" : "Mark as read"}>
      <IconButton onClick={onClick} size="small">
        {isRead ? <MarkunreadOutlinedIcon /> : <DraftsOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ToggleReadButton;
